<!--
 * 下拉框组件
 * @author 滕威
 * @time 2019-12-6
 *
-->
<!-- 模板(html)代码 start -->
<template>
  <el-cascader
    ref="cascader"
    v-model="value"
    :options="options"
    :disabled="disabled"
    :clearable="clearable"
    :filterable="filterable"
    :showAllLevels="showAllLevels"
    :props="propsData"
    :queryParams="queryParams"
    placeholder="请选择"
    @change="handleFilter"
    v-removeAriaHidden
  >
  </el-cascader>
</template>
<!-- 模板(html)代码 end -->

<!-- JS代码 start -->
<script>
// 引入axios方法
import { fun_PostAction } from "@/api";
/**
 * 组件默认导出属性
 * @author 滕威
 */
export default {
  // 初始化数据对象
  data() {
    return {
      options: [], // 下拉框数组
      value: null, // 下拉框绑定的value值
      formDate: {
        code: null, // 子组件value存放对象
        options: [] // 下拉框数组
      }
    };
  },

  // 接收来自父组件的数据
  props: {
    // 请求字典参数对象
    queryParams: {
      // required: true
    },
    url: {
      type: String,
      default: null
    },
    // 父组件绑定值
    codeSting: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showAllLevels: {
      type: Boolean,
      default: true
    },
    propsData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    clearable: {
      type: Boolean
    },
    filterable: {
      type: Boolean,
      default: true
    },
    optionData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 下拉框字段名
    field: {
      type: String,
      default: null
    },
    // 列表嵌套下拉框获取列表数据的行下标
    index: {
      type: Number,
      default: 0
    }
  },

  // 监听
  watch: {
    // 监听父组件绑定值
    codeSting: {
      // handler监听改变之后的值、改变之前的值
      handler(newName) {
        // 如果有改变的值
        if (newName) {
          // 将改变的值赋值给下拉框绑定的value值
          this.value = newName;
        } else {
          this.value = null;
        }
      },
      immediate: true,
      deep: false // 不需要深度监听
    },
    optionData: {
      handler(newVal) {
        if (newVal) {
          // 赋值
          this.options = newVal.length > 0 ? newVal : this.options;
        }
      },
      immediate: true, // 立即执行
      deep: false // 不需要深度监听
    },
    // 监听字典请求参数对象
    queryParams: {
      handler(newVal) {
        if (newVal) {
          // 赋值
          this.queryParams = newVal;
          // 请求字典
          this.fun_GetDic();
        }
      },
      immediate: true // 立即执行
    }
  },

  // 模板编译完成
  mounted() {
    // 调用字典请求方法
    this.fun_GetDic();
  },

  // 自定义事件
  methods: {
    /**
     * 下拉框change事件
     * @author 滕威
     */

    handleFilter() {
      // 将下拉框选择的value值赋值给formDate.code
      this.formDate.code = this.value;
      // 将下拉框选择的options值赋值给formDate.options
      this.formDate.options = this.options;
      // $emit事件将选择的下拉框value值发送给调用change事件者
      this.$emit("change", this.formDate, this.field, this.options);
    },

    /**
     * 请求字典方法
     * @author 滕威
     */
    async fun_GetDic() {
      // 判断传值不为空则不进行共通查询
      if (this.optionData.length == 0) {
        // 调用字典axios方法
        let res = await fun_PostAction(
          this.url ? this.url : "/combobox",
          this.queryParams
        );
        // 判断请求是否成功
        if (res.data.result) {
          // 请求成功的场合
          // 将解析的data数组赋值给下拉框
          this.options = res.data.data;
        }
      } else {
        // 将解析的data数组赋值给下拉框
        this.options = this.optionData;
      }
    }
  }
};
</script>
<!-- JS代码 end -->
